import type { AriaAttributes, CSSProperties } from "react"
import classNames from "classnames"

interface SwitchFieldProps extends Pick<AriaAttributes, "aria-label" | "aria-labelledby" | "aria-describedby"> {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  // The brand color behind the switch, which then turns on to a white track with a knob in that color.
  onColor?: string
}

// The DSL Switch Field on the global `.switch-field` classes (components/_switch_field.scss),
// which the ERB partial shares. A wrapping <label> only forwards clicks: name it with aria-*.
const SwitchField = ({ checked, onChange, disabled = false, onColor, ...aria }: SwitchFieldProps) => (
  <button
    {...aria}
    type="button"
    role="switch"
    aria-checked={checked}
    disabled={disabled}
    className={classNames("switch-field", { "switch-field-on": checked, "switch-field-on-color": onColor })}
    style={onColor ? ({ "--switch-field-brand-color": onColor } as CSSProperties) : undefined}
    onClick={() => onChange(!checked)}
  >
    <span className="switch-field-knob" />
  </button>
)

export default SwitchField
